module.exports = __webpack_public_path__ + "img/clutch-award2.583cd70e.png";